//
//  FormErrorMessage.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Typography } from "@mui/material";

type FormErrorMessageProps = {
  errorMsg?: string;
  visible?: boolean;
};

export const FormErrorMessage = ({
  errorMsg,
  visible = false,
}: FormErrorMessageProps) =>
  visible ? (
    <Typography
      color="error"
      fontSize={14}
      align="center"
      sx={{ width: "100%" }}
    >
      {errorMsg}
    </Typography>
  ) : null;
